export default __webpack_public_path__ + "static/media/SE60.08f76d90.png";